import React from 'react'
import { Smartphone, Euro, Zap } from 'lucide-react'
import { toGO } from '../navBar'

const Features = () => {
  const features = [
    {
      icon: <Smartphone className='w-6 h-6 text-blue-600' />,
      title: 'Intuitive mobile app',
      description:
        'Download our mobile app to buy digital assets instantly from your phone. Manage your digital assets from your phone anytime, anywhere.'
    },
    {
      icon: <Euro className='w-6 h-6 text-blue-600' />,
      title: 'Staking rewards',
      description:
        'Bitvavo enables you to earn a return on your digital assets. Our staking service offers a yield of up to 15% on staked assets.'
    },
    {
      icon: <Zap className='w-6 h-6 text-blue-600' />,
      title: 'Direct euro transfers',
      description:
        'Buying digital assets with euros has never been easier. Bitvavo supports 8 payment methods, including SEPA for instant transfers.'
    }
  ]

  return (
    <div className='px-4 md:px-6 max-w-7xl mx-auto'>
      <div className='flex flex-col md:flex-row md:gap-16 md:items-center'>
        {/* Features List */}
        <div className='w-full md:w-1/2 space-y-12'>
          {features.map((feature, index) => (
            <div key={index} className='flex gap-4' onClick={toGO}>
              <div className='flex-shrink-0'>
                <div className='w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-blue-50'>{feature.icon}</div>
              </div>
              <div>
                <h3 className='text-2xl font-semibold mb-2'>{feature.title}</h3>
                <p className='text-gray-600 text-lg leading-relaxed'>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Rewards Image - Hidden on Mobile */}
        <div className='hidden md:block md:w-1/2' onClick={toGO}>
          <div className='relative'>
            <img
              src='https://media.graphassets.com/output=format:avif/qjP5tG76TVGAJIluH27A'
              alt='Rewards Dashboard'
              className='w-full h-auto'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Features
